import React from 'react'
import PropTypes from 'prop-types'

const Preloader = ({ isLoading }) => (
  <div className={isLoading ? 'is-preloading' : ''}>
    <div className='preloader -with-spacing'>
      <b className='preloader__bar -bar1' />
      <b className='preloader__bar -bar2' />
      <b className='preloader__bar -bar3' />
      <b className='preloader__bar -bar4' />
      <b className='preloader__bar -bar5' />
    </div>
  </div>
)

Preloader.propTypes = {
  isLoading: PropTypes.bool
}

export default Preloader
